import { z } from "zod";

export const contentOptimizationPhases = ["learning", "action_recommended", "active"] as const;

export const contentOptimizationPhaseSchema = z.enum(contentOptimizationPhases);

export type ContentOptimizationPhase = z.infer<typeof contentOptimizationPhaseSchema>;
